import { render, staticRenderFns } from "./HeaderBtn.vue?vue&type=template&id=24412048"
import script from "./HeaderBtn.vue?vue&type=script&lang=js"
export * from "./HeaderBtn.vue?vue&type=script&lang=js"
import style0 from "./HeaderBtn.vue?vue&type=style&index=0&id=24412048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports